import React from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';

import { Box } from 'wui/Box';
import { Typography } from 'wui/Typography';

import { Layout, Column } from '../../../Layout';
import { TPAComponentProps } from 'wui/types';

type ColumnProps = {
  children: React.ReactNode;
};

interface EditEventFormLayoutProps extends TPAComponentProps {
  children: React.ReactNode;
}

export function EditEventFormLayout({
  children,
  ...rest
}: EditEventFormLayoutProps) {
  const { isMobile } = useEnvironment();

  const LeftColumn = React.Children.toArray(children).find(
    (child: any) => child.type === EditEventFormLayout.LeftColumn,
  );

  const RightColumn = React.Children.toArray(children).find(
    (child: any) => child.type === EditEventFormLayout.RightColumn,
  );

  if (isMobile) {
    return (
      <Box direction="vertical" gap="24px" {...rest}>
        {RightColumn}
        {LeftColumn}
      </Box>
    );
  }

  return (
    <Box padding="32px 0" direction="vertical" {...rest}>
      <Layout>
        <Column>
          <Box direction="vertical" gap="24px">
            {LeftColumn}
          </Box>
        </Column>
        <Column>
          <Box direction="vertical" gap="8px">
            <Typography as="label" variant="p2-14">
              &nbsp;
            </Typography>

            {RightColumn}
          </Box>
        </Column>
      </Layout>
    </Box>
  );
}

function LeftColumn({ children }: ColumnProps) {
  return <>{children}</>;
}

function RightColumn({ children }: ColumnProps) {
  return <>{children}</>;
}

LeftColumn.displayName = 'LeftColumn';
RightColumn.displayName = 'RightColumn';
EditEventFormLayout.displayName = 'EditEventFormLayout';

EditEventFormLayout.LeftColumn = LeftColumn;
EditEventFormLayout.RightColumn = RightColumn;
